function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.cartItems = document.querySelector("cart-items");
    this.removebutton = this.querySelector(".remove-button");
    this.isMarketOpen = true;
    this.marketStatusUrl = this.dataset.marketStatusUrl;
    this.instrument = this.dataset.instrument;
    this.saxoIntegration =
      this.dataset.saxoIntegration == ""
        ? true
        : this.dataset.saxoIntegration == "true";

    this.availableAmount = isInteger(this.input.dataset.inventoryAvailable)
      ? parseInt(this.input.dataset.inventoryAvailable, 10)
      : 0;

    this.incomingAmount = isInteger(this.input.dataset.incomingAmount)
      ? parseInt(this.input.dataset.incomingAmount, 10)
      : 0;

    this.inventoryPolicy = this.input.dataset.inventoryPolicy;

    this.mobileDropdown = this.querySelector("dropdown-main");
    this.mobileDropdown.effect = this.handleDropdownOptionClick;

    this.messageBox = document.getElementById(
      `message-box-${this.input.dataset.index}`,
    );
    this.querySelectorAll("button[name]").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
    console.log(this.removebutton);
    this.removebutton.addEventListener("click", (event) => {
      this.onRemoveButtonClick(event);
    });
    this.updateMarketAvailability();
  }
  async getMarketStatus() {
    const re = await fetch(
      `${this.marketStatusUrl}?instrument=${this.instrument}`,
    );
    return await re.json();
  }
  async updateMarketAvailability() {
    if (!this.saxoIntegration) {
      return;
    }

    const { marketState } = await this.getMarketStatus();
    if (marketState != "Open") {
      this.changeMessageState("marketClosed");
      this.isMarketOpen = false;
      this.cartItems.checkProductMarketStatus();
    }
  }
  onRemoveButtonClick(event) {
    event.preventDefault();
    this.input.value = "0";
    this.cartItems.update(this.input);
  }

  getNewValue(addition) {
    const currentValue = parseInt(this.input.value, 10);
    return addition == "plus" ? currentValue + 1 : currentValue - 1;
  }

  changeMessageState(cssCls) {
    this.resetInventoryMessage();
    if (cssCls) this.messageBox.classList.add(cssCls);
  }

  isEligible(cssCls) {
    return cssCls != "inventoryWarningUnavailable";
  }

  onButtonClick(event) {
    event.preventDefault();
    const selectedAmount = this.getNewValue(event.target.name);
    const cssCls = getNewState(
      selectedAmount,
      this.inventoryPolicy,
      this.availableAmount,
      this.incomingAmount,
    );
    this.changeMessageState(cssCls);

    if (this.isEligible(cssCls)) {
      this.input.value = selectedAmount;
      this.cartItems.update(this.input);
    }
  }
  onDropdownOptionValueChange(value) {
    const selectedAmount = parseInt(value, 10);

    if (selectedAmount != undefined || selectedAmount != null) {
      const cssCls = getNewState(
        selectedAmount,
        this.inventoryPolicy,
        this.availableAmount,
        this.incomingAmount,
      );
      this.changeMessageState(cssCls);

      if (this.isEligible(cssCls)) {
        this.input.value = selectedAmount;
        this.cartItems.update(this.input);
      }
    }
  }
  handleDropdownOptionClick(event) {
    event.target
      .closest("quantity-input")
      .onDropdownOptionValueChange(event.target.textContent);
  }

  resetInventoryMessage() {
    this.messageBox.classList.remove("inventoryWarningUnavailable");
    this.messageBox.classList.remove("inventoryExtraTime");
  }
}

customElements.define("quantity-input", QuantityInput);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
    this.isCheckoutPaused = false;

    this.addEventListener("change", this.debouncedOnChange.bind(this));
    this.updateDeliveryDate();
    this.checkoutBtn = document.querySelector(".checkout-btn");
  }
  checkProductMarketStatus() {
    const item = Array.from(this.querySelectorAll("quantity-input")).map(
      (i) => i.isMarketOpen,
    );
    if (item.includes(false)) {
      this.pauseCheckout();
    } else {
      this.unpauseCheckout();
    }
  }
  unpauseCheckout() {
    this.isCheckoutPaused = false;
    const ntf = document.querySelector(".market-state-ftr-ntf");
    if (ntf) {
      ntf.classList.remove("paused");
    }

    if (this.checkoutBtn) {
      this.checkoutBtn.removeAttribute("disabled");
    }
  }

  pauseCheckout() {
    /**
     * Used to pause checkout incase market is closed for one of the products
     */
    console.log("pausing");
    if (this.isCheckoutPaused) {
      console.log("pauased alrady");
      return;
    }
    this.isCheckoutPaused = true;
    const ntf = document.querySelector(".market-state-ftr-ntf");
    if (ntf) {
      ntf.classList.add("paused");
      console.log(ntf.classList, "added paused class");
    }

    if (this.checkoutBtn) {
      this.checkoutBtn.setAttribute("disabled", true);
    }
  }
  async update(inputEl) {
    console.log("called update");
    const mainSectionId = document.getElementById("main-cart-items").dataset.id;
    this.toggleLoading(inputEl.dataset.index);
    const response = await this.updateQuantity(
      inputEl.dataset.index,
      inputEl.value,
    );

    const parsedHTML = new DOMParser().parseFromString(
      response.sections[mainSectionId],
      "text/html",
    );

    this.renderFooter(parsedHTML);
    this.renderItemCount(response.item_count);
    this.renderLineItems(parsedHTML);
    this.renderMobileTotalPrice(parsedHTML, inputEl.dataset.index);
    this.updateCartBubble(response.item_count);
    this.updateMobileDropdownState(inputEl.value);
    this.updateDeliveryDate(parsedHTML);
    this.checkProductMarketStatus();
    this.toggleLoading(inputEl.dataset.index, false);

    if (response.item_count == 0) {
      document.querySelector(".cart-section").classList.add("empty-cart");
    }
  }
  updateMobileDropdownState(value) {
    const dropdown = this.querySelector("dropdown-main");

    if (dropdown) dropdown.changeState(value);
  }

  updateDeliveryDate(parsedHTML) {
    const presentUITableRow = this.querySelectorAll("#cart tr");

    var state = false;
    presentUITableRow.forEach((item) => {
      if (item.classList.contains("inventoryExtraTime")) state = true;
    });

    if (state) {
      document
        .querySelector(".delivery-info")
        .classList.add("inventoryExtraTime");
    } else {
      document
        .querySelector(".delivery-info")
        .classList.remove("inventoryExtraTime");
    }

    if (parsedHTML) {
      this.renderNewDeliveryDate(parsedHTML);
    }
  }

  renderNewDeliveryDate(parsedHTML) {
    const parsendDeliveryUL = parsedHTML.querySelector(".delivery-info-list");
    const deliveryUl = document.querySelector(".delivery-info-list");

    if (parsendDeliveryUL) {
      deliveryUl.innerHTML = parsendDeliveryUL.innerHTML;
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value);
  }

  async updateQuantity(line, quantity) {
    const mainSectionId = document.getElementById("main-cart-items").dataset.id;
    const body = JSON.stringify({
      line,
      quantity,
      sections: mainSectionId,
      sections_url: window.location.pathname,
    });
    const response = await fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body },
    });

    return JSON.parse(await response.text());
  }
  renderItemCount(parsedHTML) {
    document.querySelector(
      "#CartItemCount span",
    ).textContent = `${parsedHTML} items`;
  }
  renderMobileTotalPrice(parsedHTML, line) {
    const newTotalPriceEL = parsedHTML.getElementById(
      `mobile-total-price-${line}`,
    );
    if (newTotalPriceEL) {
      document.getElementById(`mobile-total-price-${line}`).innerHTML =
        newTotalPriceEL.innerHTML;
    }
  }

  renderFooter(parsedHTML) {
    const newFooter = parsedHTML.getElementById("CartFooter");

    if (newFooter) {
      document.getElementById("CartFooter").innerHTML = newFooter.innerHTML;
    } else {
      document.getElementById("CartFooter").innerHTML = "";
    }
  }

  renderLineItems(parsedHTML) {
    const presentUITableRow = this.querySelectorAll("#cart tr");
    const fetchedUITableRow = parsedHTML.querySelectorAll("#cart tr");

    fetchedUITableRow.forEach((item, index) => {
      if (!item.classList.contains("message-box")) {
        presentUITableRow[index].innerHTML = item.innerHTML;
      }
    });

    if (presentUITableRow.length > fetchedUITableRow.length) {
      for (
        let i = fetchedUITableRow.length;
        i < presentUITableRow.length;
        i++
      ) {
        presentUITableRow[i].innerHTML = "";
      }
    }
  }

  updateCartBubble(number) {
    document.querySelector("cart-ntfctn-bubble").render(number);
  }

  toggleLoading(line, add = true) {
    const trId = `cart-item-${line}`;
    const moibleTotalPriceId = `mobile-total-price-${line}`;
    [
      document.getElementById(moibleTotalPriceId),
      document.getElementById(trId),
      document.getElementById("CartFooter"),
    ].forEach((el) => {
      if (add && el) el.classList.add("loading");
      else if (add != true && el) el.classList.remove("loading");
    });
  }
}

customElements.define("cart-items", CartItems);
